// Currency / number / date formatting — never hard-code currency or locale.

const CURRENCY_LOCALE = {
  MAD: "fr-MA", EUR: "fr-FR", AED: "ar-AE", USD: "en-US", GBP: "en-GB",
};

export function formatMoney(cents, currency = "EUR", opts = {}) {
  const value = (cents || 0) / 100;
  const locale = CURRENCY_LOCALE[currency] || "fr-FR";
  try {
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency,
      maximumFractionDigits: opts.decimals ?? 0,
      minimumFractionDigits: opts.decimals ?? 0,
    }).format(value);
  } catch {
    return `${value.toLocaleString("fr-FR")} ${currency}`;
  }
}

export function formatNumber(n) {
  return new Intl.NumberFormat("fr-FR").format(n || 0);
}

export function formatDateLong(date = new Date(), locale = "fr-FR") {
  return new Intl.DateTimeFormat(locale, {
    weekday: "long", day: "numeric", month: "long", year: "numeric",
  }).format(date);
}

export function capitalize(s) {
  return s ? s.charAt(0).toUpperCase() + s.slice(1) : s;
}

export function formatTime(iso) {
  try {
    return new Intl.DateTimeFormat("fr-FR", { hour: "2-digit", minute: "2-digit" }).format(new Date(iso));
  } catch {
    return "";
  }
}

export function formatDateShort(iso) {
  try {
    return new Intl.DateTimeFormat("fr-FR", { day: "2-digit", month: "2-digit", year: "numeric" }).format(new Date(iso));
  } catch {
    return iso;
  }
}

export function toCents(v) {
  const n = parseFloat(String(v).replace(",", "."));
  return Number.isFinite(n) ? Math.round(n * 100) : 0;
}
